import GET from "./api/GET";
import POST from "./api/POST";
import PUT from "./api/PUT";
import PATCH from "./api/PATCH";

export const branchList = async () => {
  const token = localStorage.getItem("wow-delivery-kw-merchant-token");
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/auth`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

export const fetchBranches = async (
  page = 1,
  limit = process.env.REACT_APP_PAGINATION_LIMIT || 10,
  search
) => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/branch/get?page=${page}&limit=${limit}&search=${search}`
  );
  return response;
};

export const createNewBranch = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/branch/create`,
    { ...credentials }
  );
  return response;
};

export const editBranch = async (credentials) => {
  const response = await PUT(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/branch/update/${credentials?._id}`,
    { ...credentials }
  );
  return response;
};

export const archiveBranch = async (credentials) => {
  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/branch/archive-branch/${credentials?._id}`,
    { ...credentials }
  );
  return response;
};

export const restoreBranch = async (credentials) => {
  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/branch/restore-branch/${credentials?._id}`,
    { ...credentials }
  );
  return response;
};
